import { lazy, Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@Reducers/index";
import { closeUserProfileModals } from "@Reducers/userProfileModal";

// Lazy so the modals (GroupedUsersDetailsModal pulls in SlickGrid) stay out of
// the eager App chunk — they only load on first open.
const UserProfileModal = lazy(() => import("./index"));
const GroupedUsersDetailsModal = lazy(() => import("./GroupedUsersDetailsModal"));

/**
 * Single app-level mount for the user-profile modals, driven by the
 * userProfileModal slice. Plain-DOM grid cells (userTagDom.ts) dispatch
 * openUserProfile/openGroupedUsersModal instead of hosting the modal per cell.
 */
function UserProfileModalHost() {
  const dispatch = useDispatch();
  const userId = useSelector((state: RootState) => state.userProfileModal.userId);
  const groupIds = useSelector((state: RootState) => state.userProfileModal.groupIds);
  const groupHeader = useSelector((state: RootState) => state.userProfileModal.groupHeader);

  const close = () => dispatch(closeUserProfileModals());

  return (
    <Suspense fallback={null}>
      {userId && <UserProfileModal userId={userId} onClose={close} />}
      {groupIds?.length ? (
        <GroupedUsersDetailsModal ids={groupIds} detailsModalHeader={groupHeader} closeModal={close} />
      ) : null}
    </Suspense>
  );
}

export default UserProfileModalHost;
